var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCockpit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 2.91015 2.91015 0 6.5 0H25.5C29.0898 0 32 2.91015 32 6.5V25.5C32 29.0898 29.0898 32 25.5 32H6.5C2.91015 32 0 29.0898 0 25.5V6.5Z",
    fill: "#00C792"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72197 25.989C8.24454 25.9891 7.78662 25.7995 7.44897 25.462C4.00563 22.019 2.97544 16.8407 4.83879 12.3419C6.70214 7.84311 11.0921 4.90979 15.9615 4.90979C20.8309 4.90979 25.2208 7.84311 27.0841 12.3419C28.9475 16.8407 27.9173 22.019 24.474 25.462C23.7709 26.1651 22.631 26.1651 21.928 25.462C21.2249 24.7589 21.2249 23.6191 21.928 22.916C24.3413 20.5028 25.0632 16.8734 23.7572 13.7203C22.4512 10.5672 19.3743 8.51137 15.9615 8.51137C12.5486 8.51137 9.47179 10.5672 8.16576 13.7203C6.85973 16.8734 7.58168 20.5028 9.99497 22.916C10.5099 23.4308 10.664 24.2052 10.3853 24.8779C10.1067 25.5506 9.45013 25.9892 8.72197 25.989Z",
    fill: "url(#paint0_linear_555:1550)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.982C15.2722 17.9818 14.6163 17.5434 14.3377 16.8711C14.0591 16.1988 14.2127 15.4249 14.727 14.91L20.94 8.69401C21.6447 8.00096 22.7764 8.00579 23.4751 8.70483C24.1739 9.40386 24.1783 10.5356 23.485 11.24L17.27 17.455C16.9335 17.7925 16.4765 17.9821 16 17.982Z",
    fill: "url(#paint1_linear_555:1550)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_555:1550",
    x1: 5.61382,
    y1: 4.91701,
    x2: 5.61382,
    y2: 23.0389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_555:1550",
    x1: 18.6586,
    y1: 7.15758,
    x2: 11.2733,
    y2: 13.3509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCockpit);
export default __webpack_public_path__ + "static/media/IconCockpit.20a903c921ab96b3767214dc9da6764c.svg";
export { ForwardRef as ReactComponent };